import { Fragment, useEffect, useState } from "react";
import "./Blogs.scss";
import BlogsLanding from "./bloglanding/BlogsLanding";
import PageLayout from "../../layouts/pagelayout/PageLayout";
import AllBlogs from "./allblogs/AllBlogs";
import LoaderCard from "../../components/loaderCard/LoaderCard";

import WOW from "wow.js";

import axios from "axios";
import { baseUrl, getBlogs } from "../../utils/apiData";

const Blogs = () => {
  const [blogList, setBlogList] = useState([]);
  const [recent, setRecent] = useState({});
  const [loader, setLoader] = useState(false);
  const [threeBlog, setThreeBlog] = useState([]);
  // Get Blogs Api
  const getBlogsApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getBlogs}`);
      if (res?.data?.success) {
        setLoader(false);
        setBlogList(res?.data?.data?.blogs);
        setRecent(res?.data?.data?.recent);
        setThreeBlog(res?.data?.data?.recentemultiblogs);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getBlogsApi();

    const wow = new WOW();
    wow.init();
  }, []);

  return (
    <PageLayout>
      {loader ? (
        <LoaderCard />
      ) : (
        <Fragment>
    <BlogsLanding recent={recent} threeBlog={threeBlog}  />
          <AllBlogs blogList={blogList} />
        </Fragment>
      )}
    </PageLayout>
  );
};

export default Blogs;
